 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import U103132 from '@/components/U103132'
 import SS_US_ADULT_SIGNUP_FRONT from '@/components/SS_US_adult_signup_front'
 import LOVE_1 from '@/components/love_1'
 import N157755 from '@/components/N157755'
 import N157756 from '@/components/N157756'
 import TOC from '@/components/toc'
 import N157757 from '@/components/N157757'
 import N157758 from '@/components/N157758'
 import N157759 from '@/components/N157759'
 import N157760 from '@/components/N157760'
 import N157761 from '@/components/N157761'
 import N157762 from '@/components/N157762'
 import N157763 from '@/components/N157763'
 import N157764 from '@/components/N157764'
 import N157765 from '@/components/N157765'
 import N157766 from '@/components/N157766'
 import N157767 from '@/components/N157767'
 import N157768 from '@/components/N157768'
 import N157769 from '@/components/N157769'
 import N157770 from '@/components/N157770'
 import N157771 from '@/components/N157771'
 import N157772 from '@/components/N157772'
 import N157773 from '@/components/N157773'
 import LOVE_2 from '@/components/love_2'
 import SS_US_ADULT_SIGNUP_BACK from '@/components/SS_US_adult_signup_back'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/U103132",
 			"name" : "U103132",
 			"component" : U103132
 		},
 		{
 			"path" : "/SS_US_adult_signup_front",
 			"name" : "SS_US_adult_signup_front",
 			"component" : SS_US_ADULT_SIGNUP_FRONT
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/N157755",
 			"name" : "N157755",
 			"component" : N157755
 		},
 		{
 			"path" : "/N157756",
 			"name" : "N157756",
 			"component" : N157756
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/N157757",
 			"name" : "N157757",
 			"component" : N157757
 		},
 		{
 			"path" : "/N157758",
 			"name" : "N157758",
 			"component" : N157758
 		},
 		{
 			"path" : "/N157759",
 			"name" : "N157759",
 			"component" : N157759
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js